import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { ILessonModel } from 'models/lesson.model'
import ListItem from '../../../commons/ListItem'
import styles from './LessonList.module.scss'

interface ILessonList {
  lessons: ILessonModel[]
  draggable: boolean
  onDelete: any
  onOrderChange: any
  contentCount?: any
  onContentCountChange?: any
  actionsDisabled?: boolean
}

const LessonList: React.FC<ILessonList> = ({
  lessons,
  onDelete,
  draggable,
  onOrderChange,
  contentCount,
  onContentCountChange,
  actionsDisabled = false,
}) => {
  const history = useHistory()
  const [lessonsState, setLessons] = useState([] as ILessonModel[])

  useEffect(() => {
    setLessons(lessons)
  }, [lessons])

  const [draggingItem, setDraggingItem] = useState(undefined as any)
  const handleDragStart = (e: any, from: number) => {
    setDraggingItem(from)
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/html', null)
  }

  const handleDragOver = (e: any, to: number) => {
    e.preventDefault()
    const currentList = lessonsState
    const from = isFinite(draggingItem) ? draggingItem : 0
    currentList.splice(to, 0, currentList.splice(from, 1)[0])
    sort(currentList, to)
  }

  const sort = (list: any, dragging: any) => {
    if (contentCount) {
      ;[contentCount[dragging], contentCount[draggingItem]] = [
        contentCount[draggingItem],
        contentCount[dragging],
      ]
      onContentCountChange(contentCount)
    }
    setDraggingItem(dragging)
    setLessons(list)
    onOrderChange(list)
  }

  const checkContentCount = (index: number) => {
    return contentCount ? contentCount[index] : -1
  }

  return (
    <div className={`my-3 ${styles.lessonList}`}>
      {lessonsState.map(
        ({ id, name, courseId }: ILessonModel, index: number) => {
          return (
            <div
              key={`${id}-${index}`}
              className={styles.lessonItem}
              draggable={draggable && !actionsDisabled}
              onDragStart={(e: any) => handleDragStart(e, index)}
              onDragOver={(e: any) => handleDragOver(e, index)}
            >
              <ListItem
                id={id}
                name={`${index + 1}. ${name}`}
                dragDrop={draggable}
                disabled={draggable || actionsDisabled}
                onDelete={onDelete}
                contentCount={checkContentCount(index)}
                onEdit={() =>
                  history.push(
                    `/administration/courses/${courseId}/lessons/${id}/edit`
                  )
                }
              />
            </div>
          )
        }
      )}
    </div>
  )
}

export default LessonList
